import React, { useEffect } from 'react';

import { translate } from '@/i18n/src/locales';
import { Helmet } from 'react-helmet';

import Card from '@/components/Card';
import TitlePage from '@/components/TitlePage';
import DataTable from '@/components/DataTable';

import { fetchPoles } from '@/store/actions/pole';
import { useSelector, useDispatch } from 'react-redux';
import * as ROUTES from '@/routes/routes';

import Badge from '@/components/Badge';
import IcEdit from '@/assets/images/ic-edit.svg';
import { Link } from 'react-router-dom';

function Poles() {
  const dispatch = useDispatch();

  const poles = useSelector((state) => state.pole.poles);

  useEffect(() => {
    dispatch(fetchPoles());
  }, []);


  const typeColorStatus = (idStatus) => {
    const statusColors = ["success", "danger", "warning"];
    return statusColors[idStatus - 1] || 'info';
  };


  return (
    <>
      <Helmet>
        <title>Administração Franqueadora - {translate('poles')}</title>
      </Helmet>
      <TitlePage title={translate('poles')} link={ROUTES.POLE_CREATE} txtButton={translate('poleCreate')} />
      <Card>
        <DataTable
          data={poles}
          searchPlaceHolder={translate('searchPoleName')}
          columns={[
            { name: translate('poleName'), selector: 'nomePolo', sortable: true },
            {
              name: translate('externalCode'),
              selector: 'codigoExternoPolo',
              sortable: true,
            },
            {
              name: translate('status'),
              compact: true,
              width: '135px',
              cell: (row) => (
                <Badge type={typeColorStatus(row.idStatus)}>
                  {translate(row.statusPolo)}
                </Badge>
              ),
            },
            {
              width: '60px',
              cell: (row) => (
                <Link to={`${ROUTES.POLE_VIEW}/${row.idPolo}`}>
                  <img className="icon-edit" src={IcEdit} alt={row.idPolo} />
                </Link>
              ),
            }
          ]}
          columnFilter="nomePolo"
        />
      </Card>
    </>
  );
}

export default Poles;
